import {Module} from '@mamdev/cad.static-next-lib';
import Tracking2 from '../../ts/services/tracking2';

export default class NewTeaser extends Module {
  static attachTo(root: HTMLElement): NewTeaser {
    return new NewTeaser(root);
  }

  teaserLink: HTMLLinkElement | null;

  constructor(root: HTMLElement) {
    super(root);
    this.teaserLink = null;
  }

  start() {
    this.teaserLink = this.root_.querySelector('.teaser__link');
    if (this.teaserLink) {
      Tracking2.bindTrackingClickHandler(this.teaserLink);
    }
  }
}
